"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _DateInput = _interopRequireDefault(require("../DatePickers/DateInput"));
var _Popover = _interopRequireDefault(require("../Tooltips/Popover"));
var _TimePickerBase = _interopRequireWildcard(require("./TimePickerBase"));
var _helpers = require("../helpers");
var _excluded = ["align", "onClose", "onChange", "children", "disabled", "value", "hasError", "hideDoneButton", "placeholder", "isRequired", "w", "width", "automationHook", "isHighlighted", "withClearButton", "onClear", "clearValue", "withSeconds"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes = _objectSpread({
  // Where the popover should be aligned relative to the trigger
  align: _propTypes["default"].oneOf(["start", "center", "end"]),
  // Hook used for automation testing
  automationHook: _propTypes["default"].string,
  // Children of the component
  children: _propTypes["default"].node,
  /** Value for the field that gets set when the Input's clear button is
   * clicked. `clearValue` is important for formik to compare correct initial
   * values with the value that gets set onClear. By default it is `null`
   */
  clearValue: _propTypes["default"].any,
  // Whether the timepicker is disabled
  disabled: _propTypes["default"].bool,
  // Whether this field should be displayed as having an error
  hasError: _propTypes["default"].bool,
  // Whether to hide the done button
  hideDoneButton: _propTypes["default"].bool,
  // Whether the timepicker is required
  isRequired: _propTypes["default"].bool,
  // Function to call when the timepicker value changes
  onChange: _propTypes["default"].func.isRequired,
  // Function to call when the popover is closed
  onClose: _propTypes["default"].func,
  // The placeholder for the timepicker
  placeholder: _propTypes["default"].string,
  // Value of the timepicker
  value: _propTypes["default"].any,
  // The width of the field
  w: _propTypes["default"].string,
  // DEPRECATED: The width of the field
  width: _propTypes["default"].string,
  // Whether to hide the input clear button
  withClearButton: _propTypes["default"].bool,
  // Display seconds (default: true)
  withSeconds: _propTypes["default"].bool
}, _TimePickerBase.propTypes);
exports.propTypes = propTypes;
var timeStringFromSeconds = function timeStringFromSeconds(seconds, withSeconds) {
  var hours = Math.floor(seconds / (60 * 60));
  var minutes = Math.floor((seconds - hours * (60 * 60)) / 60);
  var restSeconds = Math.floor(seconds - hours * (60 * 60) - minutes * 60);
  var hoursAndMinutes = "".concat(hours < 10 ? "0" : "").concat(hours, ":").concat(minutes < 10 ? "0" : "").concat(minutes);
  return "".concat(hoursAndMinutes).concat(withSeconds ? ":".concat(restSeconds < 10 ? "0" : "").concat(restSeconds) : "");
};
var TimePicker = function TimePicker(_ref) {
  var align = _ref.align,
    onClose = _ref.onClose,
    _onChange = _ref.onChange,
    children = _ref.children,
    disabled = _ref.disabled,
    value = _ref.value,
    hasError = _ref.hasError,
    hideDoneButton = _ref.hideDoneButton,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "--:--:--" : _ref$placeholder,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    w = _ref.w,
    width = _ref.width,
    automationHook = _ref.automationHook,
    isHighlighted = _ref.isHighlighted,
    withClearButton = _ref.withClearButton,
    onClear = _ref.onClear,
    _ref$clearValue = _ref.clearValue,
    clearValue = _ref$clearValue === void 0 ? null : _ref$clearValue,
    _ref$withSeconds = _ref.withSeconds,
    withSeconds = _ref$withSeconds === void 0 ? true : _ref$withSeconds,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    timeValue = _useState2[0],
    setTimeValue = _useState2[1];
  var timeValueFormatted = typeof timeValue === "number" ? timeStringFromSeconds(timeValue, withSeconds) : "";
  (0, _helpers.useDeprecate)({
    width: width
  }, "TimePicker");
  var handleClear = function handleClear() {
    setTimeValue(clearValue);
    _onChange(clearValue);
  };
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    onClose: onClose,
    align: align,
    triggerW: w !== null && w !== void 0 ? w : width,
    renderTrigger: children || function (_ref2) {
      var togglePopover = _ref2.togglePopover,
        isOpen = _ref2.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        togglePopover: togglePopover,
        hasError: hasError,
        value: timeValueFormatted,
        isRequired: isRequired,
        placeholder: placeholder,
        isOpen: isOpen,
        disabled: disabled,
        automationHook: (0, _automationHooks.getHook)(automationHook, "trigger"),
        isHighlighted: isHighlighted,
        withClearButton: withClearButton,
        onClear: handleClear
      });
    }
  }, function (_ref3) {
    var closePopover = _ref3.closePopover,
      isOpen = _ref3.isOpen;
    return /*#__PURE__*/_react["default"].createElement(_TimePickerBase["default"], _extends({
      isOpen: isOpen,
      onDoneClick: closePopover,
      value: timeValueFormatted,
      onChange: function onChange(seconds) {
        setTimeValue(seconds);
        _onChange(seconds);
      },
      hideDoneButton: hideDoneButton
    }, rest));
  });
};
TimePicker.propTypes = propTypes;
var _default = TimePicker;
exports["default"] = _default;